import { isEqual } from 'lodash';
import { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWillUnMount } from '../../../../../../hooks/life-cycle';
import { CsvActions } from '../../../../../../redux/csv/csv.action';
import { State } from '../../../../../../redux/root.reducer';
import { Limit, TableSort } from '../../../../../ui/table/table-sort/table-sort';
import { CsvListProject } from '../../list/project/csv-list-project';
import { CsvSearchBoxProject } from '../../search-box/project/csv-search-box-project';
import { CsvProjectSort } from '../../../../../../type/csv/csv-sort.type';
import { DateFormatter } from '../../../../../../utilities/date-formatter';
import { CsvModel } from '../../../../../../model/csv/csv-model';
import { useAppSelector } from '../../../../../../hooks/use-redux';

type Props = {
  callback: (v: () => void) => void;
}

export const CsvProject = (props:Props) => {
  const { callback } = props;

  /* Hooks */
  const dispatch = useDispatch();
  const sortState = useSelector((state: State) => (state.csv.projectSort), isEqual);
  const list = useSelector((state: State) => (state.csv.projectList), isEqual);
  const hitCount = useAppSelector((v) => (v.csv.projectCount));

  /* State */
  const [selected, setSelected] = useState<number[]>([]);

  /* Callback */
  const getList = useCallback((v?: CsvProjectSort) => {
    const sortData = v || sortState;
    dispatch(CsvActions.api.project.getList(CsvModel.projectEx(sortData)));
    setSelected([]);
  },
  [sortState]);

  const changePagination = useCallback((offset:number, limit:Limit) => {
    dispatch(CsvActions.setProjectList(null));
    dispatch(CsvActions.setProjectSort({ offset, limit }));
    getList({ ...sortState, offset, limit });
  }, []);

  /* Effect */
  useEffect(() => {
    getList();
  }, [
    sortState.highlow,
    sortState.sort_by,
  ]);

  return (
    <>
      <CsvSearchBoxProject
        callback={(v) => {
          dispatch(CsvActions.setProjectList(null));
          getList(v);
        }}
      />
      <TableSort
        page={sortState.offset ?? 0}
        limit={sortState.limit as Limit}
        hitCount={hitCount || 0}
        callback={changePagination}
      />
      <CsvListProject
        callbackSelected={setSelected}
      />
      <TableSort
        className="bottom"
        page={sortState.offset ?? 0}
        limit={sortState.limit as Limit}
        hitCount={hitCount || 0}
        callback={changePagination}
      />
    </>
  );
};
